import { useScript } from "@src/shared/hooks/useScript";
import { noop } from "radashi";
import { PropsWithChildren, useMemo } from "react";
import { AnalyticsContext } from "./AnalyticsContext";

type Props = PropsWithChildren;

function AnalyticsProvider({ children }: Props) {
  const loaded = useScript(
    "https://umami.hyselect.app/app.js",
    { defer: true },
    {
      "data-domains": import.meta.env.VITE_UMAMI_DOMAINS,
      "data-website-id": import.meta.env.VITE_UMAMI_WEBSITE_ID,
    },
  );
  const tracker = useMemo(
    () => (loaded ? { identify, trackEvent } : undefined),
    [loaded],
  );

  return (
    <AnalyticsContext.Provider value={{ tracker }}>
      {children}
    </AnalyticsContext.Provider>
  );
}

export default AnalyticsProvider;

function fireAndForget<T>(promise: Promise<T>) {
  promise.then(noop).catch(noop);
}

function identify(uniqueId: string, eventData?: umami.EventData) {
  if (window.umami) {
    if (eventData === undefined) {
      fireAndForget(window.umami.identify(uniqueId));
    } else {
      fireAndForget(window.umami.identify(uniqueId, eventData));
    }
  }
}

function trackEvent(eventName: string, eventData?: umami.EventData) {
  if (window.umami) {
    if (eventData === undefined) {
      fireAndForget(window.umami.track(eventName));
    } else {
      fireAndForget(window.umami.track(eventName, eventData));
    }
  }
}
